import type { Option } from '@byecode/ui'
import { getAssetUrl } from '@lighthouse/assets'
import { type NavigationShowMode } from '@lighthouse/core'
import type { RadioItem } from '@lighthouse/shared'

import type { JumpLinkOption } from './NavBarItem'

export const jumpLinkOptions: JumpLinkOption[] = [
    {
        label: '链接',
        value: 1,
        placeholder: '请输入'
    },
    {
        label: '页面',
        value: 2,
        placeholder: '请选择页面'
    }
]

export const jumpButton: RadioItem[] = [
    {
        label: '主按钮',
        value: 1,
        name: 'jumpButton'
    },
    {
        label: '次按钮',
        value: 2,
        name: 'jumpButton'
    }
]

export const navbarModeList: {
    id: number
    label: string
    icon: string
    value: NavigationShowMode
}[] = [
    {
        id: 0,
        label: '水平',
        icon: getAssetUrl('application', 'navbar_mode_horizontal.svg'),
        value: 1
    },
    {
        id: 1,
        label: '垂直',
        icon: getAssetUrl('application', 'navbar_mode_vertical_wide.svg'),
        value: 2
    }
    // {
    //     id: 2,
    //     label: '垂直-较窄',
    //     icon: navbarModeVerticalNarrow,
    //     value: 3
    // }
]
